// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"711bf51e","112":"3d775581"}[chunkId] + ".chunk.css";
};